import { atom } from 'jotai';

export const isStickyBarCollapsedAtom = atom(false);

export const hasSubSportsMenuAtom = atom(false);